import Axios from 'axios';

const RESOURCE_NAME_CATEGORYS = '/Categorias';
const RESOURCE_NAME_FUEL = '/Caracteristicas/Combustibles';
const RESOURCE_NAME_BODYSTYPES = '/Carrocerias/Categoria/';
const RESOURCE_NAME_YEARS = '/Caracteristicas/Anos';
const RESOURCE_NAME_BRANDS = '/Jato/MarcasWL';
const RESOURCE_REGIONES = '/Regiones';
const RESOURCE_CIUDADES = '/Ciudades/Region/';
const RESOURCE_COMUNAS = '/Comunas/Ciudad/';
const RESOURCE_PLANES = '/planes/getPlanes/0';

const oldAPI = process.env.VUE_APP_WS_ENDPOINT;

export default {

  filters: {
    getPlanes() {
      return Axios.get(`${RESOURCE_PLANES}`);
    },
    regiones() {
      return Axios.get(`${oldAPI}${RESOURCE_REGIONES}`);
    },
    ciudades(idRegion) {
      return Axios.get(`${oldAPI}${RESOURCE_CIUDADES}${idRegion}`);
    },
    comunas(idCiudad) {
      return Axios.get(`${oldAPI}${RESOURCE_COMUNAS}${idCiudad}`);
    },

    categorys() {
      return Axios.get(`${oldAPI}${RESOURCE_NAME_CATEGORYS}`);
    },
    years(brand) {
      return Axios.get(`${oldAPI}${RESOURCE_NAME_YEARS}`);
    },
    fuels() {
      return Axios.get(`${oldAPI}${RESOURCE_NAME_FUEL}`);
    },
    bodytypes(category) {
      return Axios.get(`${oldAPI}${RESOURCE_NAME_BODYSTYPES}${category}`);
    },
    brands(data) {
      return Axios.post(`${oldAPI}${RESOURCE_NAME_BRANDS}`, data);
    },
    transmissions() {
      let transmissions = [{
          value: "A",
          caption: "Automática"
        },
        {
          value: "M",
          caption: "Manual"
        }
      ];
      return transmissions;
    }
  },
  marketing: {
    filters: {
      categorys() {
        let transmissions = [{
            value: "4",
            caption: "Citroen"
          },
          {
            value: "3",
            caption: "Lead"
          }
        ];
        return transmissions;
      }
    }
  }
};